import { jsx as _jsx } from "react/jsx-runtime";
import { Button } from '@mui/material';
import { useContext } from 'react';
import { CommonContext } from '../context/CommonContext';
import { theme } from '../themes';
export const OfflineButton = (props) => {
    const { noBorder, sx, size, variant, color, onClick, startIcon, text, className, ...rest } = props;
    const { isOnline } = useContext(CommonContext);
    const offlineColor = theme.palette.offline.main;
    const border = noBorder ? 'unset' : `1px solid ${offlineColor}`;
    const restProps = !isOnline ? { ...rest, component: undefined } : rest;
    return (_jsx(Button, { ...restProps, className: !isOnline ? '' : className, color: !isOnline ? 'offline' : color || 'primary', variant: !isOnline ? 'outlined' : variant, size: size, startIcon: startIcon, onClick: !isOnline ? undefined : onClick, disableRipple: !isOnline, sx: {
            ...sx,
            ...(!isOnline && {
                cursor: 'default',
                border: border,
                borderColor: noBorder ? 'transparent' : `${offlineColor} !important`,
                '&:hover': {
                    border: border,
                },
            }),
        }, children: text }));
};
